import { createSlice } from '@reduxjs/toolkit';

import { estelamSabtAhvalThunk } from 'Feature/Common/Common/Actions/Thunks/estelamSabtAhvalThunk';
import { getActiveModdatHayeBimehNameh } from 'Feature/Common/Common/Actions/Thunks/getActiveModdatHayeBimehNameh';
import { getAddressWithPostCodeThunk } from 'Feature/Common/Common/Actions/Thunks/getAddressWithPostCodeThunk';
import { SefrKiloometrEnum } from 'Feature/Khodro/Common/Enums/SefrKiloometrEnum';
import { GetAllAnvaeSherkatBimeh } from 'Feature/Khodro/Common/Thunks/GetAllAnvaeSherkatBimeh';
import { getAllAnvaePelak } from 'Feature/Khodro/Common/Thunks/getAllAnvaePelak';
import { getAllAnvaeVasilehNaghleyeh } from 'Feature/Khodro/Common/Thunks/getAllAnvaeVasilehNaghleyeh';
import { getAllBrandHaByNoeVasilehNaghlieh } from 'Feature/Khodro/Common/Thunks/getAllBrandHaByNoeVasilehNaghlieh';
import { getAllHarfHayePelak } from 'Feature/Khodro/Common/Thunks/getAllHarfHayePelak';
import { getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh } from 'Feature/Khodro/Common/Thunks/getAllMoredEstefadehHayeKhodro';
import { getAllRangHayeKhodro } from 'Feature/Khodro/Common/Thunks/getAllRangHayeKhodro';
import { getAllTipHaByBrand } from 'Feature/Khodro/Common/Thunks/getAllTipHaByBrand';
import { getEstelamBimehMarkazi } from 'Feature/Khodro/Common/Thunks/getEstelamBimehMarkazi';
import { getSerialHayePelakByHarfPelak } from 'Feature/Khodro/Common/Thunks/getSerialHayePelakByHarfPelak';
import { addToOrder } from 'Feature/Khodro/ShakhsSales/Thunks/addToOrder';
import { estelamShakhsSales } from 'Feature/Khodro/ShakhsSales/Thunks/estelamShakhsSales';
import { getActiveTaahodSalesJaani } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveTaahodSalesJaani';
import { getActiveTaahodSalesSarneshin } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveTaahodSalesSarneshin';
import { getAllCountries } from 'Feature/Khodro/ShakhsSales/Thunks/getAllCountries';
import { getAllTaahodatSalesMali } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTaahodatSalesMali';
import { getAllTakhfifHayeJarimehSales } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTakhfifHayeJarimehSales';
import { getAllTakhfifHayeJarimehSarneshin } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTakhfifHayeJarimehSarneshin';
import { getAllTarhHayeSodoorByNoeBimeh } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTarhHayeSodoorByNoeBimeh';
import { getBimehNamehExpireDateMaxDay } from 'Feature/Khodro/ShakhsSales/Thunks/getBimehNamehExpireDateMaxDay';
import { getCodeShenasehPardakhtShakhsSalesWithoutPelak } from 'Feature/Khodro/ShakhsSales/Thunks/getCodeShenasehPardakhtShakhsSalesWithoutPelak';
import isDuplicateBimehNamehShakhsSalesInOrder from 'Feature/Khodro/ShakhsSales/Thunks/isDuplicateBimehNamehShakhsSalesInOrder';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';

import IRangKhodro from '../../../Models/IRangKhodro';
import ITakhfifHayeJarimehSalesQr from '../../../Queries/ITakhfifHayeJarimehSalesQr';
import ITakhfifHayeJarimehSarneshinQr from '../../../Queries/ITakhfifHayeJarimehSarneshinQr';
import StepOneModelInitialState from '../Components/01-StepOne/Models/StepOneModelInitialState';
import StepTwoModelInitialState from '../Components/02-StepTwo/Models/StepTwoModelInitialState';
import StepThreeModelInitialState from '../Components/03-StepThree/Models/StepThreeModelInitialState';
import StepFourModelInitialState from '../Components/04-StepFour/Models/StepFourModelInitialState';
import StepFifthModelInitialState from '../Components/05-StepFifth/Models/StepFifthModelInitialState';
import StepSixModelInitialState from '../Components/06-StepSix/Models/StepSixModelInitialState';

import BimehNamehInitialState from './InitialStates/BimehNamehInitialState';
import ShakhsSalesBimehNamehEstelamAndSodoorInitialState from './ShakhsSalesBimehNamehEstelamAndSodoorInitialState';

export const shakhsSalesBimehNamehEstelamAndSodoorSlice = createSlice({
  name: 'ShakhSales/EstelamAndSodoor',
  initialState: ShakhsSalesBimehNamehEstelamAndSodoorInitialState,
  reducers: {
    setEstelamAndSodoorBimehNamehInitialState: (state) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand =
        ShakhsSalesBimehNamehEstelamAndSodoorInitialState.getCodeShenasehPardakhtShakhsSalesCommand;
      state.isMablaghKharidBimehNamehMoreThanHaghBimeh =
        ShakhsSalesBimehNamehEstelamAndSodoorInitialState.isMablaghKharidBimehNamehMoreThanHaghBimeh;
      state.isSuccess = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.isSuccess;
      state.stepOneData = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.stepOneData;
      state.stepTwoData = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.stepTwoData;
      state.stepThreeData = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.stepThreeData;
      state.stepFourData = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.stepFourData;
      state.stepFiveData = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.stepFiveData;
      state.estelamBimehMarkaziModel = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamBimehMarkaziModel;
      state.estelamBimehMarkaziResult = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamBimehMarkaziResult;
      state.estelamShakhsSalesCommand = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamShakhsSalesCommand;
      state.estelamSalesResult = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamSalesResult;
      state.getCodeShenasehPardakhtShakhsSalesResult =
        ShakhsSalesBimehNamehEstelamAndSodoorInitialState.getCodeShenasehPardakhtShakhsSalesResult;
      state.anvaePelak = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.anvaePelak;
      state.anvaeVasilehNaghleyeh = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.anvaeVasilehNaghleyeh;
      state.tarhTakhfif = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.tarhTakhfif;
      state.taahodatSalesMali = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.taahodatSalesMali;
      state.moredEstefadehHayeKhodro = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.moredEstefadehHayeKhodro;
      state.brandHa = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.brandHa;
      state.tipHa = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.tipHa;
      state.anvaePelak = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.anvaePelak;
      state.rangHa = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.rangHa;
      state.taahodatSalesSarneshin = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.taahodatSalesSarneshin;
      state.taahodatSalesJaani = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.taahodatSalesJaani;
      state.countries = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.countries;
      state.anvaeSherkatBimeh = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.anvaeSherkatBimeh;
      state.serialPelaks = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.serialPelaks;
      state.addToOrderResponse = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.addToOrderResponse;
      state.wizard = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.wizard;
      state.niazBeEstelamBimehMarkazi = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.niazBeEstelamBimehMarkazi;
      state.takhfifHayeJarimehSarneshin = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.takhfifHayeJarimehSarneshin;
      state.haghBimehPardakhti = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.haghBimehPardakhti;
    },

    setStepOneModel: (state, action) => {
      state.stepOneData = action.payload;
      state.estelamSalesResult.loaded = false;
    },
    clearStepOneModel: (state) => {
      state.stepOneData = StepOneModelInitialState;
    },
    setStepOneCommand: (state, action) => {
      const sefrKiloometr: SefrKiloometrEnum = action.payload.sefrKiloometr;
      state.estelamShakhsSalesCommand.vehicleInfo.noeVasilehNaghleyeh = action.payload.noeVasilehNaghleyeh;
      state.estelamShakhsSalesCommand.vehicleInfo.moredEstefadehCoreId = action.payload.moredEstefadehCoreId;
      state.estelamShakhsSalesCommand.vehicleInfo.noePelakCoreId = action.payload.noePelakCoreId;
      state.estelamShakhsSalesCommand.vehicleInfo.brandCoreId = action.payload.brandCoreId;
      state.estelamShakhsSalesCommand.vehicleInfo.tipCoreId = action.payload.tipCoreId;
      state.estelamShakhsSalesCommand.vehicleInfo.sefrKiloometr = sefrKiloometr;
      state.estelamShakhsSalesCommand.shadowFields.vaziatBimehNamehGhabli = sefrKiloometr;
      state.estelamShakhsSalesCommand.vehicleInfo.saleSakht = action.payload.saleSakht;
      state.estelamShakhsSalesCommand.vehicleInfo.taghvimSaleSakht = action.payload.taghvimSaleSakht;
    },
    setRangInCodeShenasehCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.rangCoreId = action.payload;
    },
    setStepTwoModel: (state, action) => {
      state.stepTwoData = action.payload;
      state.estelamSalesResult.loaded = false;
    },
    setStepTwoCommand: (state, action) => {
      state.estelamShakhsSalesCommand.bimehNameh.darsadTakhfifHavadesBG = action.payload.darsadTakhfifHavadesBG;
      state.estelamShakhsSalesCommand.bimehNameh.darsadTakhfifSalesBG = action.payload.darsadTakhfifSalesBG;
      state.estelamShakhsSalesCommand.bimehNameh.modatBimehNamehGhabl = action.payload.modatBimehNamehGhabl;
      state.estelamShakhsSalesCommand.bimehNameh.tarikhSarresidGhabli = action.payload.tarikhSarresidGhabli;
      state.estelamShakhsSalesCommand.bimehNameh.tarikhShoroo = action.payload.tarikhShoroo;
      state.estelamShakhsSalesCommand.bimehNameh.vaziatKhesaratHavadesBGCoreId =
        action.payload.vaziatKhesaratHavadesBGCoreId;
      state.estelamShakhsSalesCommand.bimehNameh.vaziatKhesaratSalesBGCoreId =
        action.payload.vaziatKhesaratSalesBGCoreId;
    },
    clearStepTwoModel: (state) => {
      state.stepTwoData = StepTwoModelInitialState;
    },
    clearBimehNamehCommand: (state) => {
      state.estelamShakhsSalesCommand.bimehNameh = BimehNamehInitialState;
    },
    setStepThreeModel: (state, action) => {
      state.stepThreeData = action.payload;
    },
    clearStepThreeModel: (state) => {
      state.stepThreeData = StepThreeModelInitialState;
    },
    setEstelamShakhsSalesCommand: (state, action) => {
      state.estelamShakhsSalesCommand = action.payload;
    },
    setStepFourModel: (state, action) => {
      state.stepFourData = action.payload;
    },
    clearStepFourModel: (state) => {
      state.stepFourData = StepFourModelInitialState;
    },
    setStepFiveModel: (state, action) => {
      state.stepFiveData = action.payload;
    },
    clearStepFiveModel: (state) => {
      state.stepFiveData = StepFifthModelInitialState;
    },
    setStepFiveCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.tarafHayeGharardad = action.payload;
    },
    setStepSixModel: (state, action) => {
      state.stepSixData = action.payload;
    },
    clearStepSixModel: (state) => {
      state.stepSixData = StepSixModelInitialState;
    },
    setStepSixCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.codePosti = action.payload.codePosti;
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.mobile = action.payload.mobile;
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.tel = action.payload?.tel;
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.neshani = action.payload.neshani;
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.cityCoreId = action.payload.cityCoreId;
      state.getCodeShenasehPardakhtShakhsSalesCommand.address.email = action.payload?.email;
    },
    clearEstelamResult: (state) => {
      state.estelamSalesResult.data = null;
    },
    clearEstelamCommand: (state) => {
      state.estelamShakhsSalesCommand = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamShakhsSalesCommand;
      state.wizard = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.wizard;
      state.taahodatMaliEstelamResult = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.taahodatMaliEstelamResult;
      state.haghBimehPardakhti = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.haghBimehPardakhti;
      state.isSuccess = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.isSuccess;
    },
    setHaghBimehPardakhtiCommand: (state, action) => {
      state.haghBimehPardakhti = action.payload;
    },
    estelamAndSodoorWizardNextStep: (state) => {
      let nextStep = 0;
      nextStep = state.wizard.current + 1;
      if (nextStep <= state.wizard.end) {
        state.wizard.current = nextStep;
      }
    },
    estelamAndSodoorWizardPreviousStep: (state) => {
      let previousStep = 0;
      previousStep = state.wizard.current - 1;
      if (previousStep >= state.wizard.begin) {
        state.wizard.current = previousStep;
      }
    },
    setTarafHayeGharardadCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.tarafHayeGharardad = action.payload;
    },
    setEstelamBimehMarkaziModel: (state, action) => {
      state.estelamBimehMarkaziModel = action.payload;
    },
    setEstelamBimehMarkaziCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehBimehNameh =
        action.payload.shomarehBimehNameh;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehMotor = action.payload.shomarehMotor;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehShasi = action.payload.shomarehShasi;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.codeYektaBimehMarkazi =
        action.payload.codeYektaBimehMarkazi;
    },
    clearEstelamBimehMarkaziModel: (state) => {
      state.stepFourData = StepFourModelInitialState;
    },
    setShowConfirmFromUser: (state, action) => {
      state.showConfirmFromUser = action.payload;
    },

    setNiazBeEstelamBimehMarkazi: (state, action) => {
      state.niazBeEstelamBimehMarkazi = action.payload;
    },

    clearEstelamBimehMarkazi: (state) => {
      state.estelamBimehMarkaziResult = ShakhsSalesBimehNamehEstelamAndSodoorInitialState.estelamBimehMarkaziResult;
    },
    clearSodoorCommand: (state) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand =
        ShakhsSalesBimehNamehEstelamAndSodoorInitialState.getCodeShenasehPardakhtShakhsSalesCommand;
    },
    setIsMablaghKharidBimehNamehMoreThanHaghBimeh: (state, action) => {
      state.isMablaghKharidBimehNamehMoreThanHaghBimeh = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEstelamBimehMarkazi.pending, (state) => {
        state.estelamBimehMarkaziResult.loading = true;
      })
      .addCase(getEstelamBimehMarkazi.fulfilled, (state, action) => {
        state.estelamBimehMarkaziResult.loading = false;
        state.estelamBimehMarkaziResult.data = action.payload;
      })
      .addCase(getEstelamBimehMarkazi.rejected, (state) => {
        state.estelamBimehMarkaziResult.loading = false;
      });

    builder
      .addCase(getAllCountries.pending, (state) => {
        state.countries.loading = true;
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.countries.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.countries.data = list;
        }
        return state;
      })
      .addCase(getAllCountries.rejected, (state) => {
        state.countries.loading = false;
      });

    builder
      .addCase(GetAllAnvaeSherkatBimeh.pending, (state) => {
        state.anvaeSherkatBimeh.loading = true;
      })
      .addCase(GetAllAnvaeSherkatBimeh.fulfilled, (state, action) => {
        state.anvaeSherkatBimeh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.bimehMarkaziTitle,
          }));
          state.anvaeSherkatBimeh.data = list;
        }
        return state;
      })
      .addCase(GetAllAnvaeSherkatBimeh.rejected, (state) => {
        state.anvaeSherkatBimeh.loading = false;
      });

    builder
      .addCase(getCodeShenasehPardakhtShakhsSalesWithoutPelak.pending, (state) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = true;
      })
      .addCase(getCodeShenasehPardakhtShakhsSalesWithoutPelak.fulfilled, (state, action) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = false;
        if (action.payload && action.payload.status === 201) {
          state.getCodeShenasehPardakhtShakhsSalesResult.data = action.payload.data;
          state.isSuccess = true;
        } else {
          state.isSuccess = false;
        }
        return state;
      })
      .addCase(getCodeShenasehPardakhtShakhsSalesWithoutPelak.rejected, (state) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = false;
      });

    builder
      .addCase(addToOrder.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addToOrder.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addToOrder.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });

    builder
      .addCase(getSerialHayePelakByHarfPelak.pending, (state) => {
        state.serialPelaks.loading = true;
      })
      .addCase(getSerialHayePelakByHarfPelak.fulfilled, (state, action) => {
        state.serialPelaks.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.serial,
        }));
        state.serialPelaks.data = list;
      })
      .addCase(getSerialHayePelakByHarfPelak.rejected, (state) => {
        state.serialPelaks.loading = false;
      });

    builder
      .addCase(getAllAnvaeVasilehNaghleyeh.pending, (state) => {
        state.anvaeVasilehNaghleyeh.loading = true;
      })
      .addCase(getAllAnvaeVasilehNaghleyeh.fulfilled, (state, action) => {
        state.anvaeVasilehNaghleyeh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.anvaeVasilehNaghleyeh.data = list;
        }
        return state;
      })
      .addCase(getAllAnvaeVasilehNaghleyeh.rejected, (state) => {
        state.anvaeVasilehNaghleyeh.loading = false;
      });
    builder
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.pending, (state) => {
        state.moredEstefadehHayeKhodro.loading = true;
      })
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.fulfilled, (state, action) => {
        state.moredEstefadehHayeKhodro.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.moredEstefadehHayeKhodro.data = list;
        }
        return state;
      })
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.rejected, (state) => {
        state.moredEstefadehHayeKhodro.loading = false;
      });

    builder
      .addCase(getActiveModdatHayeBimehNameh.pending, (state) => {
        state.moddatHayeBimehNameh.loading = true;
      })
      .addCase(getActiveModdatHayeBimehNameh.fulfilled, (state, action) => {
        state.moddatHayeBimehNameh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.id,
            label: item.title,
          }));
          state.moddatHayeBimehNameh.data = list;
        }
        return state;
      })
      .addCase(getActiveModdatHayeBimehNameh.rejected, (state) => {
        state.moddatHayeBimehNameh.loading = false;
      });

    builder
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.pending, (state) => {
        state.brandHa.loading = true;
      })
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.fulfilled, (state, action) => {
        state.brandHa.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.brandHa.data = list;
        }
        return state;
      })
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.rejected, (state) => {
        state.brandHa.loading = false;
      });
    builder
      .addCase(getAllTipHaByBrand.pending, (state) => {
        state.tipHa.loading = true;
      })
      .addCase(getAllTipHaByBrand.fulfilled, (state, action) => {
        state.tipHa.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.name,
            isDefault: item.isDefault,
          }));
          state.tipHa.data = list;
        }
        return state;
      })
      .addCase(getAllTipHaByBrand.rejected, (state) => {
        state.tipHa.loading = false;
      });
    builder
      .addCase(getAllAnvaePelak.pending, (state) => {
        state.anvaePelak.loading = true;
      })
      .addCase(getAllAnvaePelak.fulfilled, (state, action) => {
        state.anvaePelak.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.anvaePelak.data = list;
        }
        return state;
      })
      .addCase(getAllAnvaePelak.rejected, (state) => {
        state.anvaePelak.loading = false;
      });
    builder
      .addCase(getActiveTaahodSalesJaani.pending, (state) => {
        state.taahodatSalesJaani.loading = true;
      })
      .addCase(getActiveTaahodSalesJaani.fulfilled, (state, action) => {
        state.taahodatSalesJaani.loading = false;
        if (action.payload !== undefined) {
          const item: LabelValueType = {
            value: action.payload.mablaghTaahod,
            label: `${action.payload.mablaghTaahod?.toLocaleString()} ${action.payload.vahedPooli}`,
          };
          state.taahodatSalesJaani.data = item;
        }
        return state;
      })
      .addCase(getActiveTaahodSalesJaani.rejected, (state) => {
        state.taahodatSalesJaani.loading = false;
      });
    builder
      .addCase(getAllTaahodatSalesMali.pending, (state) => {
        state.taahodatSalesMali.loading = true;
      })
      .addCase(getAllTaahodatSalesMali.fulfilled, (state, action) => {
        state.taahodatSalesMali.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.mablaghTaahod,
            label: `${item.mablaghTaahod?.toLocaleString()} ${item.vahedPooli}`,
          }));
          state.taahodatSalesMali.data = list;
        }
        return state;
      })
      .addCase(getAllTaahodatSalesMali.rejected, (state) => {
        state.taahodatSalesMali.loading = false;
      });
    builder
      .addCase(getAllTakhfifHayeJarimehSales.pending, (state) => {
        state.takhfifHayeJarimehSales.loading = true;
      })
      .addCase(getAllTakhfifHayeJarimehSales.fulfilled, (state, action) => {
        state.takhfifHayeJarimehSales.loading = false;
        if (action.payload !== undefined) {
          const list: ITakhfifHayeJarimehSalesQr[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.title,
            tedadJaani: item.tedadJaani,
            tedadMaali: item.tedadMaali,
            tedadSarneshin: item.tedadSarneshin,
          }));
          state.takhfifHayeJarimehSales.data = list;
        }

        return state;
      })
      .addCase(getAllTakhfifHayeJarimehSales.rejected, (state) => {
        state.takhfifHayeJarimehSales.loading = false;
      });
    builder
      .addCase(getAllTakhfifHayeJarimehSarneshin.pending, (state) => {
        state.takhfifHayeJarimehSarneshin.loading = true;
      })
      .addCase(getAllTakhfifHayeJarimehSarneshin.fulfilled, (state, action) => {
        state.takhfifHayeJarimehSarneshin.loading = false;
        if (action.payload !== undefined) {
          const list: ITakhfifHayeJarimehSarneshinQr[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.title,
            tedadJaani: item.tedadJaani,
            tedadMaali: item.tedadMaali,
            tedadSarneshin: item.tedadSarneshin,
          }));
          state.takhfifHayeJarimehSarneshin.data = list;
        }

        return state;
      })
      .addCase(getAllTakhfifHayeJarimehSarneshin.rejected, (state) => {
        state.takhfifHayeJarimehSarneshin.loading = false;
      });
    builder
      .addCase(getAllTarhHayeSodoorByNoeBimeh.pending, (state) => {
        state.tarhTakhfif.loading = true;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.fulfilled, (state, action) => {
        state.tarhTakhfif.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.tarhTakhfif.data = list;
        }
        return state;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.rejected, (state) => {
        state.tarhTakhfif.loading = false;
      });
    builder
      .addCase(getAllRangHayeKhodro.pending, (state) => {
        state.rangHa.loading = true;
        state.rangHaLabelValueType.loading = true;
      })
      .addCase(getAllRangHayeKhodro.fulfilled, (state, action) => {
        state.rangHa.loading = false;
        if (action.payload !== undefined) {
          state.rangHa.data = action.payload;
          const list: LabelValueType[] = action.payload?.map((item: IRangKhodro) => ({
            value: item.coreId,
            label: item.description,
            extraData: item.colorHash,
          }));
          state.rangHaLabelValueType.data = list;
        }
        return state;
      })
      .addCase(getAllRangHayeKhodro.rejected, (state) => {
        state.rangHaLabelValueType.loading = false;
      });
    builder
      .addCase(estelamSabtAhvalThunk.pending, (state) => {
        state.estelamSabtAhval.loading = true;
      })
      .addCase(estelamSabtAhvalThunk.fulfilled, (state, action) => {
        state.estelamSabtAhval.loading = false;
        state.estelamSabtAhval.data = action.payload;
      })
      .addCase(estelamSabtAhvalThunk.rejected, (state) => {
        state.estelamSabtAhval.loading = false;
      });

    builder
      .addCase(getAddressWithPostCodeThunk.pending, (state) => {
        state.getAddressWithPostCode.loading = true;
      })
      .addCase(getAddressWithPostCodeThunk.fulfilled, (state, action) => {
        state.getAddressWithPostCode.loading = false;
        state.getAddressWithPostCode.data = action.payload;
      })
      .addCase(getAddressWithPostCodeThunk.rejected, (state) => {
        state.getAddressWithPostCode.loading = false;
      });

    builder
      .addCase(getActiveTaahodSalesSarneshin.pending, (state) => {
        state.taahodatSalesSarneshin.loading = true;
      })
      .addCase(getActiveTaahodSalesSarneshin.fulfilled, (state, action) => {
        state.taahodatSalesSarneshin.loading = false;
        if (action.payload !== undefined) {
          const item: LabelValueType = {
            value: action.payload.mablaghTaahod,
            label: `${action.payload.mablaghTaahod?.toLocaleString()} ${action.payload.vahedPooli}`,
          };
          state.taahodatSalesSarneshin.data = item;
        }
        return state;
      })
      .addCase(getActiveTaahodSalesSarneshin.rejected, (state) => {
        state.taahodatSalesSarneshin.loading = false;
      });
    builder
      .addCase(estelamShakhsSales.pending, (state) => {
        state.estelamSalesResult.loading = true;
      })
      .addCase(estelamShakhsSales.fulfilled, (state, action) => {
        state.estelamSalesResult.loading = false;
        if (action.payload && action.payload.status === 201) {
          state.estelamSalesResult.data = action.payload.data;
          state.isSuccess = true;
          state.estelamSalesResult.loaded = true;
        } else {
          state.estelamSalesResult.data = null;
          state.isSuccess = false;
        }
        return state;
      })
      .addCase(estelamShakhsSales.rejected, (state) => {
        state.estelamSalesResult.loading = false;
      });
    builder
      .addCase(getBimehNamehExpireDateMaxDay.pending, (state) => {
        state.bimehNamehExpireDateMaxDay.loading = true;
      })
      .addCase(getBimehNamehExpireDateMaxDay.fulfilled, (state, action) => {
        state.bimehNamehExpireDateMaxDay.loading = false;
        if (action.payload !== undefined) {
          state.bimehNamehExpireDateMaxDay.data = action.payload;
        }
        return state;
      })
      .addCase(getBimehNamehExpireDateMaxDay.rejected, (state) => {
        state.bimehNamehExpireDateMaxDay.loading = false;
      });

    builder
      .addCase(getAllHarfHayePelak.pending, (state) => {
        state.harfHayePelak.loading = true;
      })
      .addCase(getAllHarfHayePelak.fulfilled, (state, action) => {
        state.harfHayePelak.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.id,
          label: item.title,
        }));
        state.harfHayePelak.data = list;
      })
      .addCase(getAllHarfHayePelak.rejected, (state) => {
        state.harfHayePelak.loading = false;
      });

    builder
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.pending, (state) => {
        state.isDuplicateBimehNamehInOrder.loading = true;
        state.isDuplicateBimehNamehInOrder.data = null;
      })
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.fulfilled, (state, action) => {
        state.isDuplicateBimehNamehInOrder.loading = false;
        if (action.payload !== undefined) {
          state.isDuplicateBimehNamehInOrder.data = action.payload;
        }
        return state;
      })
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.rejected, (state) => {
        state.isDuplicateBimehNamehInOrder.loading = false;
      });
  },
});

export const {
  setStepOneModel,
  setStepOneCommand,
  setRangInCodeShenasehCommand,
  setStepTwoModel,
  setStepTwoCommand,
  clearStepTwoModel,
  clearBimehNamehCommand,
  setStepThreeModel,
  setStepFourModel,
  setStepFiveModel,
  setStepFiveCommand,
  setStepSixModel,
  setStepSixCommand,
  clearEstelamResult,
  clearEstelamCommand,
  setHaghBimehPardakhtiCommand,
  estelamAndSodoorWizardNextStep,
  estelamAndSodoorWizardPreviousStep,
  setTarafHayeGharardadCommand,
  setEstelamShakhsSalesCommand,
  setEstelamBimehMarkaziModel,
  setEstelamBimehMarkaziCommand,
  clearEstelamBimehMarkaziModel,
  setShowConfirmFromUser,
  setNiazBeEstelamBimehMarkazi,
  setIsMablaghKharidBimehNamehMoreThanHaghBimeh,
  clearSodoorCommand,
  clearEstelamBimehMarkazi,
  clearStepFiveModel,
  clearStepFourModel,
  clearStepOneModel,
  clearStepSixModel,
  clearStepThreeModel,
  setEstelamAndSodoorBimehNamehInitialState,
} = shakhsSalesBimehNamehEstelamAndSodoorSlice.actions;

export default shakhsSalesBimehNamehEstelamAndSodoorSlice.reducer;
